import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../core/services/AuthService';

export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.hasRoleAuth('ADMINISTRADOR')) {
    return true; // El token tiene el rol, permite el paso
  }

  // Si no tiene el rol, lo mandamos a una página de error o al login
  router.navigate(['/forbidden']);
  return false;
};